module.exports = __webpack_public_path__ + "media/images/official/special_double_life_worry_community-892cad402031fc1ab66d5e61d386a158.png";